import { gql } from 'graphql-tag'

export const getFooter = gql`
  query GetFooter($site: [String]) {
    globalSets(site: $site) {
      ... on certificates_GlobalSet {
        certificate {
          ... on certificate_Entry {
            id
            title
            icon {
              id
              title
              url
            }
            certificateLinks {
              ... on certificateLinks_Entry {
                id
                title
                file {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
